import React from 'react'

export const ClockVector = () => (
  <svg
    className="MIRECO-clock"
    width="24"
    height="24"
    viewBox="0 0 6.3499998 6.3499998"
    version="1.1"
  >
    <g
      transform="translate(0,-290.65)"
    >
      <circle
        r="1.8520833"
        cy="293.82501"
        cx="3.175"
        style={{
          fill: 'none',
          fillOpacity: 0.271255,
          stroke: '#333333',
          strokeWidth: 0.396875,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeDashoffset: 5.39717,
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
        }}
      />
      <path
        d="m 3.175,293.825 0,-1.19063"
        style={{
          fill: 'none',
          stroke: '#333333',
          strokeWidth: 0.396875,
          strokeLinecap: 'round',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
      />
      <path
        d="m 3.175,293.825 0.79375,0.52917"
        style={{
          fill: 'none',
          stroke: '#333333',
          strokeWidth: 0.396875,
          strokeLinecap: 'round',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
      />
      <circle
        r="0.26458332"
        cy="293.82501"
        cx="3.175"
        style={{
          fill: '#333333',
          fillOpacity: 1,
          stroke: 'none',
          strokeWidth: 0.132292,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeDashoffset: 5.39717,
          strokeOpacity: 1,
        }}
      />
    </g>
  </svg>
)
